import type {Palette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.DATALENS_NEO_20,
    scheme: [
        '#DB9101',
        '#4DA2F1',
        '#8AD554',
        '#BA74B3',
        '#FF3D64',
        '#FFC636',
        '#0CA18C',
        '#DBA2D7',
        '#BF2543',
        '#84D1EE',
        '#6B6B6B',
        '#EEB184',
        '#1E69A9',
        '#FF7E00',
        '#54A520',
        '#B9B0AC',
        '#58A9C8',
        '#FFB46C',
        '#70C1AF',
        '#FF90A1',
    ],
    datalens: true,
} as Palette;
